let prix_totale;
let prix_couleur=0.05;
let prix_board=15*15*prix_couleur;
let prix_acc=0;
let prix_losange=0;
setInterval(()=>{
  calcul_prix_couleur();
  // if(board_type=="square"){
  //   if(board_x==15 && board_y==15){
  //     prix_board=89;
  //     prix_totale=prix_board+prix_acc+prix_losange;
  //   }
  //   else{
  //     prix_board=(board_x*3+3)*(board_x*3+3)*prix_couleur;
  //     prix_totale=prix_board+prix_acc+prix_losange;
  //   }
  // }
  if(board_type=="rectangle"){
    if(board_x==15 && board_y==15){
      if(board_color==pin){
        prix_board = boards_prix['39909546754126'] // Pin
      } else if(board_color==bouleau){
        prix_board = boards_prix['32714946019406'] // Bouleau
      } else if(board_color==noir){
        prix_board = boards_prix['32771826417742'] // Noir
      } else if(board_color==rouge){
        prix_board = boards_prix['32766868226126'] // Rouge
      } else if(board_color==jaune){
        prix_board = boards_prix['32766778277966'] // Jaune
      } else if(board_color==violet){
        prix_board = boards_prix['32710223331406'] // Violet
      } else if(board_color==bleu){
        prix_board = boards_prix['32586207133774'] // Bleu
      } else if(board_color==vert){
        prix_board = boards_prix['32739408216142'] // Vert
      } else if(board_color==orange){
        prix_board = boards_prix['46461296968028'] // Orange
      } else if(board_color==gris){
        prix_board = boards_prix['46461420732764'] // Gris
    // } else if(board_color==marron){
    //   prix_board = boards_prix[] //Marron
      }
      prix_totale=prix_board+prix_acc+prix_losange;
    }
    else if((board_x==15 && board_y==31) ||(board_y==15 && board_x==31) ){
      if(board_color==pin){
        prix_board = boards_prix['39908009181262'] // Pin
      } else if(board_color==bouleau){
        prix_board = boards_prix['32714787913806'] // Bouleau
      } else if(board_color==noir){
        prix_board = boards_prix['32614683738190'] // Noir
      } else if(board_color==rouge){
        prix_board = boards_prix['32714791485518'] // Rouge
      } else if(board_color==jaune){
        prix_board = boards_prix['32743742767182'] // Jaune
      } else if(board_color==violet){
        prix_board = boards_prix['32607363891278'] // Violet
      } else if(board_color==bleu){
        prix_board = boards_prix['32607369363534'] // Bleu
      } else if(board_color==vert){
        prix_board = boards_prix['32625036066894'] // Vert
      } else if(board_color==orange){
        prix_board = boards_prix['32743749419086'] // Orange
      } else if(board_color==gris){
        prix_board = boards_prix['46461423026524'] // Gris
      // } else if(board_color==marron){
      //  prix_board = boards_prix[] //Marron
      }
      prix_totale=prix_board+prix_acc+prix_losange;
    }
    else{
      prix_board=(board_x*3+3)*(board_y*3+3)*prix_couleur;
      prix_totale=prix_board+prix_acc+prix_losange;
    }
  }
  else if(board_type=="circle"){
    if(board_x==15 && board_y==15){
      if(board_color==pin){
        prix_board = boards_prix['46462130192732'];//Pin
      } else if(board_color==bouleau){ 
        prix_board = boards_prix['32850152587342'];//Bouleau
      } else if(board_color==noir){ 
        prix_board = boards_prix['39373637288014'];//Noir
      } else if(board_color==rouge){ 
        prix_board = boards_prix['39373636796494'];//Rouge
      } else if(board_color==jaune){ 
        prix_board = boards_prix['39373636960334'];//Jaune
      } else if(board_color==violet){ 
        prix_board = boards_prix['39373637222478'];//Violet
      } else if(board_color==bleu){ 
        prix_board = boards_prix['39373636632654'];//Bleu
      }  else if(board_color==vert){
        prix_board = boards_prix['39373637025870'];//Vert
      } else if(board_color==orange){ 
        prix_board = boards_prix['39373636894798'];//Orange
      }  else if(board_color==gris){
        prix_board = boards_prix['39373637025870'];//Gris
      // } else if(board_color==marron){ 
      //   prix_board = boards_prix[39373637517390];//Marron
      }
      prix_totale=prix_board+prix_acc+prix_losange;
    }
    else{
      prix_board=(board_x*3+3)*(board_x*3+3)*prix_couleur;
      prix_totale=prix_board+prix_acc+prix_losange;
    }
  }
  $("#tool-full-price p").html("Total : <span style='color:white;cursor:default'>"+Math.round(prix_totale*10)/10+"</span>"+device_symbole+"")
})

// Fonction pour changer le prix de couleur //
function calcul_prix_couleur(){
  if(board_color==pin){
    prix_couleur = boards_prix['44325087805762'];//Pin
  } else if(board_color==bouleau){ 
    prix_couleur = boards_prix['32710206226510'];//Bouleau
  } else if(board_color==noir){ 
    prix_couleur = boards_prix['32710206259278'];//Noir
  } else if(board_color==rouge){ 
    prix_couleur = boards_prix['32710206292046'];//Rouge
  } else if(board_color==jaune){ 
    prix_couleur = boards_prix['32768523927630'];//Jaune
  } else if(board_color==violet){ 
    prix_couleur = boards_prix['32710206357582'];//Violet
  } else if(board_color==bleu){ 
    prix_couleur = boards_prix['32710206259278'];//Bleu
  }  else if(board_color==vert){ 
    prix_couleur = boards_prix['32710206324814'];//Vert
  } else if(board_color==orange){ 
    prix_couleur = boards_prix['46461194928476'];//Orange
  } else if(board_color==gris){
    prix_couleur = boards_prix['46461295657308'];//Gris
  // } else if(board_color==marron){
  //   prix_couleur = boards_prix[46461194994012];//Marron
  }
}